<div data-test-id="payments-list">
  <h4 class="mt-3">
    {{ 'paymentModule.payments' | translate }}
  </h4>
  <table class="table">
    <thead>
      <tr class="d-flex d-md-table-row">
        <th scope="col" class="d-none d-md-table-cell">
          {{ 'general.dateCreated' | translate }}
        </th>
        <th *ngIf="hasDueLaterPayments()" scope="col" class="col">
          {{ 'paymentModule.dueDate' | translate }}
        </th>
        <th scope="col" class="col">{{ 'general.status' | translate }}</th>
        <th scope="col" class="col">{{ 'general.type' | translate }}</th>
        <th scope="col" class="col">{{ 'general.amount' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let payment of payments"
        data-test-id="payment-list-row"
      >
        <tr class="d-flex flex-wrap d-md-table-row" data-test-id="payment-row">
          <td class="col-12 border-0-md-down col-md-auto">
            <p class="small d-md-none mb-1">
              {{ 'general.dateCreated' | translate }}</p
            >
            {{ payment.date | dateFromMoment | date: 'HH:mm' }} -
            {{ payment.date | formatDate: 'EE d MMM y' | async }}
          </td>

          <td
            class="col"
            [hidden]="!hasDueLaterPayments()"
            data-test-id="payment-row-due-date"
          >
            <ng-container *ngIf="payment.dueDate">
              {{ payment.dueDate | formatDate: 'EE d MMM' | async }}
            </ng-container>
          </td>

          <td data-test-id="payment-list-row-status" class="col">
            <span
              data-test-id="payment-row-status"
              class="badge"
              [ngClass]="{
                'bg-success':
                  payment.collectStatus ===
                  CollectStatusType.COLLECT_STATUS_COLLECTED,
                'bg-soft-primary':
                  payment.collectStatus ===
                    CollectStatusType.COLLECT_STATUS_COLLECTABLE ||
                  payment.collectStatus ===
                    CollectStatusType.COLLECT_STATUS_VERIFY,
                'bg-soft-secondary':
                  payment.collectStatus ===
                    CollectStatusType.COLLECT_STATUS_CANCEL ||
                  payment.collectStatus ===
                    CollectStatusType.COLLECT_STATUS_REFUNDED ||
                  payment.collectStatus ===
                    CollectStatusType.COLLECT_STATUS_REFUND_INITIALIZED ||
                  payment.collectStatus ===
                    CollectStatusType.COLLECT_STATUS_CHARGEBACK
              }"
              ><ng-container
                *ngIf="
                  payment.dueDate &&
                    payment.collectStatus ==
                      CollectStatusType.COLLECT_STATUS_COLLECTABLE;
                  else collectStatusBlock
                "
                >{{ 'saleModule.dueLaterAmount' | translate }}</ng-container
              >
              <ng-template #collectStatusBlock
                >{{
                  'saleModule.collectStatusType' + payment.collectStatus
                    | translate
                }}
              </ng-template>
            </span>
          </td>

          <td data-test-id="payment-list-pay-method" class="col">
            <span
              *ngIf="payment.payMethod >= 0"
              class="badge"
              data-test-id="payment-row-type"
              [ngClass]="{
                'bg-success':
                  payment.payMethod === PayMethodType.PAY_METHOD_INVOICE,
                'bg-soft-primary':
                  payment.payMethod != PayMethodType.PAY_METHOD_INVOICE,
                'bg-soft-secondary':
                  payment.payMethod === PayMethodType.PAY_METHOD_UNDECIDED
              }"
              >{{
                'saleModule.payMethodType' + payment.payMethod | translate
              }}</span
            >
          </td>
          <td data-test-id="payment-list-row-amount" class="col">{{
            payment.amount | currency
          }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
